import React from 'react';
import SEOHead from '../ui/SEOHead';
import PageHero from '../ui/PageHero';
import AppointmentForm from '../ui/AppointmentForm';
import useScrollReveal from '../../hooks/useScrollReveal';
import { PRACTICE_INFO, OFFICE_HOURS } from '../../data/navigation';
import s from './BookPage.module.css';

export default function BookPage() {
  useScrollReveal();
  return (
    <>
      <SEOHead
        title="Book an Appointment | Celebrity Smile Studio"
        description="Request a dental appointment at Celebrity Smile Studio in Flourtown, PA. New patients welcome. Same-day emergency slots available. Call (215) 233-5811."
        canonical="/book-appointment"
      />
      <PageHero
        eyebrow="Schedule a Visit"
        title="Book Your<br/><em>Appointment</em>"
        subtitle="New patients welcome. Fill out the form below and we'll confirm within one business day."
        breadcrumbs={[{ label: 'Book Appointment' }]}
        image="https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=1600&q=80"
      />

      <section className="section" style={{ background: 'var(--blue-50)' }}>
        <div className="container">
          <div className={s.layout}>

            {/* ── Left: Info ── */}
            <div className={"reveal " + s.infoCol}>
              <p className="eyebrow">Contact Info</p>
              <h2 className="display-heading" style={{ marginBottom: '20px' }}>
                We'd Love to<br/><em>See You</em>
              </h2>
              <p className={s.intro}>
                Whether you're a new patient or returning, we're excited to serve you.
                Fill out the form or reach us directly — our team will reach out promptly.
              </p>

              {[
                { icon: '📞', label: 'Phone',   value: <a href={`tel:${PRACTICE_INFO.phoneRaw}`} className={s.contactLink}>{PRACTICE_INFO.phone}</a> },
                { icon: '📠', label: 'Fax',     value: PRACTICE_INFO.fax },
                { icon: '📍', label: 'Address', value: PRACTICE_INFO.fullAddress },
              ].map((item, i) => (
                <div key={i} className={s.contactCard}>
                  <div className={s.contactIcon}>{item.icon}</div>
                  <div>
                    <div className={s.contactLabel}>{item.label}</div>
                    <div className={s.contactValue}>{item.value}</div>
                  </div>
                </div>
              ))}

              <h4 className={s.hoursHeading}>Office Hours</h4>
              <div className={s.hoursGrid}>
                {OFFICE_HOURS.map((h, i) => (
                  <div key={i} className={s.hoursCard}>
                    <div className={s.hoursDay}>{h.day}</div>
                    <div className={s.hoursTime} style={{ color: h.closed ? 'var(--slate-400)' : 'var(--blue-900)' }}>
                      {h.hours}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ── Right: Form ── */}
            <div className={"reveal reveal-delay-2 " + s.formCol}>
              <AppointmentForm />
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
